/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import React from 'react';

import { OuiToast } from '../../../../src/components';

export default () => (
  <div>
    <OuiToast title="Example of a good toast" onClose={() => {}}>
      <p>
        A good toast message is short and to the point. It should very rarely
        include multiple paragraphs.
      </p>
    </OuiToast>
  </div>
);
